export default __webpack_public_path__ + "static/media/back-icon.a174c6f4.svg";